import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { Link } from "react-router-dom";

function LinkButton(props) {
  const [returnButton, setReturnButton] = useState();

  const linkButton = (
    <Link to={props.url}>
      <Button
        size="lg"
        variant={props.variant}
        onClick={props.function}
        style={{
          margin: "auto",
          width: props.buttonWidth,
          height: props.buttonHeight,
          fontSize: props.buttonFontSize,
        }}
      >
        {props.title}{props.icon}
      </Button>
    </Link>
  );
  const button = (
    <Button
      size="lg"
      variant={props.variant}
      onClick={props.function}
      style={{
        margin: "auto",
        width: props.buttonWidth,
        height: props.buttonHeight,
        fontSize: props.buttonFontSize,
        color: props.fontColor,
        backgroundColor: props.backgroundColor,
        border: props.border
      }}
    >
      {props.title}{props.icon}
    </Button>
  );
  const newTabButton = (
    <Button
      size="lg"
      variant={props.variant}
      style={{
        margin: "auto",
        width: props.buttonWidth,
        height: props.buttonHeight,
        fontSize: props.buttonFontSize,
      }}
      href={props.url}
      target="_blank"
    >
      {props.title}{props.icon}
    </Button>
  );
  const handleReturnButton = () => {
    if (props.url) {
      setReturnButton(linkButton);
    }
    if (!props.url) {
      setReturnButton(button);
    }
    if (props.newTab) {
      setReturnButton(newTabButton);
    }
  };

  useEffect(() => {
    handleReturnButton();
  }, []);

  return returnButton;
}

export default LinkButton;
